import { render, staticRenderFns } from "./scroll-x.vue?vue&type=template&id=34560e65&"
import script from "./scroll-x.vue?vue&type=script&lang=js&"
export * from "./scroll-x.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports